import React from "react"
import JobsComponent from "../../components/Jobs"
import Layout from "../../components/layout"

const MarketingPage = () => (
  <Layout>
    <div>
      <JobsComponent
        image="https://i.postimg.cc/kMZBp3cD/Facebook-Messenger.png"
        title="An expounder who wants to communicate and collaborate."
        intro="We’re looking for a visionary passionate about spreading our mission throughout the internet. It requires you to be familiar with the latest trends and making sure Views is covering whatever is the latest."
        skills="This person should manage many social media accounts and not hesitate to interact. They should also be well acquaintanced with the press and constantly be trying to promote Views."
        end="Most importantly, they should be able to listen to what people want. They should promote Views and take all feedback into consideration, passing messages between different sections of the team. If you're interested, email ceo@viewsnews.co."
      />
    </div>
  </Layout>
)

export default MarketingPage
